var map = {
	"./components/activation/activation.html": 782,
	"./components/forgot-password/forgot-password.html": 783,
	"./components/login/login.html": 784,
	"./components/register/register.html": 785,
	"./components/reset-password/reset-password.html": 786,
	"./config/locales/en.json": 787,
	"./config/locales/fr_CA.json": 788
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;


//////////////////
// WEBPACK FOOTER
// ./signin \.(html|json|woff|woff2|ttf|eot|svg|gif|png)$
// module id = 781
// module chunks = 0